<template>
  <div class="eq-main">
    <select-nav
      :tab-array="tabArray"
      :default-index="defaultTabIndex"
      @change="changeTab"
    ></select-nav>
    <div class="main main-table">
      <div class="query-bar">
        <el-form
          inline
          class="fl"
        >
          <el-form-item>
            <el-select
              v-model="filterParam.timeType"
              placeholder="请选择"
              @change="timeSelectChange"
            >
              <el-option
                v-for="item of timeTypeArray"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-show="filterParam.timeType === 0"
              v-model="timeRange"
              size="medium"
              :clearable="false"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              style="width: 250px;vertical-align: middle;border-radius:4px 0 0 4px;"
              type="daterange"
              range-separator="-"
            ></el-date-picker>
            <el-date-picker
              v-show="filterParam.timeType !== 0"
              v-model="month"
              class="month-picker"
              size="medium"
              :clearable="false"
              value-format="yyyy-MM"
              type="month"
            ></el-date-picker>
            <el-button
              size="small"
              style="margin-left: -5px;line-height: 14px;height:36px;border-radius: 0 4px 4px 0;"
              @click="timeSearchClick"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <div class="bar-search">
          <el-input
            v-model="title"
            placeholder="输入模板名称"
            @change="searchTitle"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="searchTitle"
            ></i>
          </el-input>
        </div>
        <a
          class="export-btn fr"
          @click="exportData"
        >
          导出表格
        </a>
      </div>
      <div
        v-if="tableShow === true"
        class="list list-select-no-all"
      >
        <el-table
          :data="dataList"
          class="usageTable"
          style="width: 100%"
        >
          <el-table-column
            label="模板名称"
            fixed
            width="330"
          >
            <template slot-scope="scope">
              <img
                :src="getFileUrl(scope.row)"
                alt="头像图片"
                width="40"
                height="40"
                style="vertical-align: middle;margin-right: 20px;"
              />
              <span
                class="ellipsis"
                style="max-width: 240px;overflow: hidden;display: inline-block; vertical-align: middle;cursor: pointer;"
                @click="openDetail(scope.row)"
              >{{ scope.row.temp_name }}</span>
            </template>
          </el-table-column>

          <el-table-column :width="filterParam.attrGroupId === 15 ? 240 : 160">
            <template v-slot:header>
              <span
                v-if="filterParam.attrGroupId !== 7 && filterParam.attrGroupId !== 14"
                style="display:flex;align-items:center;"
              >
                <el-select
                  v-model="filterParam.platForm"
                  size="small"
                  placeholder="请选择"
                  style="width: 130px;"
                  @change="priceSelectChange"
                >
                  <el-option
                    v-for="item of deviceArray"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
              <span v-else>平台</span>
            </template>
            <template slot-scope="scope">
              <template v-if="[7, 14].includes(filterParam.attrGroupId)">
                {{ parseInt(scope.row.platform) === 1 ? 'PC' : '全平台' }}
              </template>
              <template v-else>
                {{ parseInt(scope.row.platform) === 1 ? 'PC' : 'APP' }}
              </template>
              <el-tooltip
                v-if="scope.row.status === 3"
                :content="scope.row.notSaleReason"
                class="item"
                effect="dark"
                placement="top"
              >
                <span style="color: #acafb1;">(已下架)</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            v-if="filterParam.attrGroupId !== 15 && filterParam.attrGroupId !== 14"
            align="right"
            width="160"
          >
            <template v-slot:header>
              <span
                style="display:flex;align-items:center;"
              >
                <el-select
                  v-model="filterParam.price"
                  size="small"
                  placeholder="请选择"
                  style="width: 130px;"
                  @change="priceSelectChange"
                >
                  <el-option
                    v-for="item of priceArray[filterParam.attrGroupId]"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </span>
            </template>
            <template slot-scope="scope">
              {{ scope.row.order_amount === 0 ? '免费' : scope.row.order_amount }}
            </template>
          </el-table-column>

          <el-table-column
            v-if="filterParam.attrGroupId !== mobanEnum.GC"
            :width="filterParam.attrGroupId === 14 ? '150' : filterParam.attrGroupId === 10 || filterParam.attrGroupId === 15 ? '180' : '130'"
            align="right"
            header-align="right"
          >
            <template v-slot:header>
              <item-order
                v-if="filterParam.attrGroupId !== 14"
                :orders="(filterParam.attrGroupId !== 7 && filterParam.attrGroupId !== 15) ? ['asc', 'desc'] : []"
                :default-order="orders.actual_costs"
                :tip="filterParam.attrGroupId === 7 ? '该数据包含模板使用订单金额（历史数据）及下载订单金额' : ''"
                name="订单金额"
                @change="itemChange"
              />
              <span v-else>会员订单金额</span>
            </template>
            <template slot-scope="scope">
              {{ (filterParam.timeType === 1 && filterParam.attrGroupId !== 14) ? scope.row.actual_costs : (scope.row.share_should_total_fee ? Math.floor(scope.row.share_should_total_fee / 100) : 0) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="filterParam.attrGroupId !== 14"
            :width="filterParam.attrGroupId === 10 || filterParam.attrGroupId === 15 ? '180' : '150'"
            align="right"
            header-align="right"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.order_counts"
                :name="filterParam.attrGroupId === 15 ? '付费下载订单量' : '付费订单量'"
                :tip="filterParam.attrGroupId !== 15 ? '该数据包含模板使用订单（历史数据）及下载订单' : ''"
                @change="itemChange"
              />
            </template>
            <template
              slot-scope="scope"
            >
              {{ (filterParam.timeType === 1 && filterParam.attrGroupId !== 14) ? scope.row.order_counts : scope.row.share_order_count }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="filterParam.attrGroupId === 7 || filterParam.attrGroupId === 15"
            :width="filterParam.attrGroupId === 10 || filterParam.attrGroupId === 15 ? '220' : '180'"
            align="right"
            header-align="right"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.valid_counts"
                name="会员下载量"
                tip="该数据为非去重数据，仅供参考"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.valid_counts }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="!(filterParam.attrGroupId === 15 || filterParam.attrGroupId === mobanEnum.GC)"
            :align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            :header-align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            :width="filterParam.attrGroupId === 14 ? 180 : 150"
          >
            <template v-slot:header>
              <item-order
                v-if="filterParam.attrGroupId === 14"
                :key="1"
                :orders="['asc', 'desc']"
                :default-order="orders.share_order_count"
                :name="'会员引导量'"
                :tip="''"
                @change="itemChange"
              />
              <item-order
                v-else-if="filterParam.timeType === 1 && (filterParam.attrGroupId === 2 || filterParam.attrGroupId === 10)"
                :key="2"
                :orders="['asc', 'desc']"
                :default-order="orders.product_member_valid_work"
                :name="'会员使用量'"
                :tip="'会员使用模板量（非去重）'"
                @change="itemChange"
              />
              <item-order
                v-else
                :key="3"
                :orders="['asc', 'desc']"
                :default-order="orders.xk_temp_free4creative"
                :name="'会员使用量'"
                :tip="'会员使用模板量（非去重）'"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{
                filterParam.attrGroupId === 14 ? scope.row.share_order_count :
                filterParam.timeType === 1 && (filterParam.attrGroupId === 2 || filterParam.attrGroupId === 10) ? scope.row.product_member_valid_work || 0 :
                scope.row.xk_temp_free4creative
              }}
            </template>
          </el-table-column>
          <!-- 按交易时间H5、长页新增字段 -->
          <div v-if="filterParam.timeType === 1 && (filterParam.attrGroupId === mobanEnum.H5 || filterParam.attrGroupId == mobanEnum.Hl)">
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.template_exposure_uv"
                  name="曝光uv"
                  tip="当月数据从3号开始更新"
                  @change="itemChange"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.template_exposure_uv }}
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.update_work_users"
                  name="编辑人数"
                  tip="编辑过模板的用户数，当月数据从3号开始更新"
                  @change="itemChange"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.update_work_users }}
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.valid_work_users"
                  name="制作人数"
                  tip="过模板创建完整作品的用户数，当月数据从3号开始更新"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.valid_work_users }}
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.valid_work_count"
                  name="作品量"
                  tip="通过模板创建的完整作品量，当月数据从3号开始更新"
                  @change="itemChange"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.valid_work_count }}
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.product_valid_work_pv"
                  name="作品pv"
                  tip="通过模板创建的作品传播PV，当月数据从3号开始更新"
                  @change="itemChange"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.product_valid_work_pv }}
              </template>
            </el-table-column>
            <el-table-column
              align="right"
              header-align="right"
              width="120"
            >
              <template v-slot:header>
                <item-order
                  :orders="['asc', 'desc']"
                  :default-order="orders.valid_point"
                  name="质量分"
                  tip="模板综合质量分，由模板吸引力、可用性、影响力共同决定"
                  @change="itemChange"
                />
              </template>
              <template slot-scope="scope">
                {{ scope.row.valid_point }}
              </template>
            </el-table-column>
          </div>

          <el-table-column
            v-if="filterParam.timeType === 0"
            :align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            :header-align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            min-width="150"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.valid_work_users"
                name="制作人数"
                tip="截止昨日通过模板创建有效作品的用户人数"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.valid_work_users }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="filterParam.timeType === 0"
            :align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            :header-align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            min-width="150"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.valid_work_count"
                name="作品量"
                tip="截止昨日用户通过模板创建的有效作品数"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.valid_work_count }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="filterParam.timeType === 0"
            :align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            :header-align="filterParam.attrGroupId === 14 ? 'center' : 'right'"
            min-width="150"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.product_valid_work_pv"
                name="作品pv"
                tip="截止昨日用户通过模板创建的有效作品PV"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.product_valid_work_pv }}
            </template>
          </el-table-column>
          <el-table-column
            min-width="200"
          >
            <template v-slot:header>
              <item-order
                :orders="['asc', 'desc']"
                :default-order="orders.temp_create_time"
                name="模板上线时间"
                @change="itemChange"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.prodCreateTime | formatDate }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="filterParam.attrGroupId === 2"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <a
                v-if="scope.row.status !== 3 && scope.row.order_amount !== 0 && filterParam.attrGroupId === 2"
                class="link-gray"
                @click="editPriceFunc(scope.row)">改价格</a>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          v-if="page.pageSize < page.total"
          :current-page.sync="page.pageNo"
          :page-size="page.pageSize"
          :background="true"
          :total="page.total"
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from 'src/utils/date'
import ItemOrder from 'src/components/headOrder/order'
import { showkerScenes, getLastUpdatePrice } from 'api/showker'
import SelectNav from '../components/Nav'

export default {
  name: 'UsageStatistics',
  components: {
    ItemOrder,
    SelectNav
  },
  filters: {
    formatDate(time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    fenToYuan(fen) {
      if (fen) {
        return (fen / 100).toFixed(2) + ''
      } else {
        return '0.00'
      }
    }
  },
  data() {
    return {
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate) {
            let day = 31
            if (this.filterParam.timeType === 0) {
              day = 180
            }
            const one = day * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      tableShow: true,
      choiceDate: '',
      dataList: [],
      // 0-样例，1-长页，2-表单
      selectType: 0,
      defaultTabIndex: 0,
      tabArray: ['H5模板', '海报模板', '长页模板', '互动模板', '视频模板'], // '表单'
      mobanEnum: {
        H5: 2,
        H2: 7,
        Hl: 10,
        GC: 14,
        VIDEO: 15
      },
      timeRange: '',
      month: '',
      defaultStartDate: '',
      title: '',
      filterParam: {
        pageNo: 1,
        pageSize: 10,
        sortBy: 'desc',
        status: '',
        title: '',
        beginDate: '2018-01-29',
        endDate: '2019-01-16',
        orderField: 'temp_create_time',
        timeType: 0,
        platForm: '',
        price: '',
        attrGroupId: 2
      },
      page: {
        total: 1,
        pageNo: 1,
        pageSize: 10
      },
      priceArray: {
        2: [
          { value: '', name: '全部价格' },
          { value: 0, name: '免费' },
          { value: 9, name: '9' },
          { value: 19, name: '19' },
          { value: 29, name: '29' },
          { value: 39, name: '39' },
          { value: 49, name: '49' },
          { value: 59, name: '59' },
          { value: 69, name: '69' },
          { value: 99, name: '99' },
          { value: 129, name: '129' },
          { value: 199, name: '199' }
        ],
        7: [
          { value: '', name: '全部价格' },
          { value: 0, name: '免费' },
          { value: 3, name: '3' },
          { value: 6, name: '6' },
          { value: 9, name: '9' },
          { value: 15, name: '15' },
          { value: 16, name: '16' },
          { value: 19, name: '19' }
        ],
        10: [
          { value: '', name: '全部价格' },
          { value: 0, name: '免费' },
          { value: 9, name: '9' },
          { value: 19, name: '19' },
          { value: 29, name: '29' },
          { value: 29, name: '49' }
        ]
      },
      timeTypeArray: [
        { value: 0, name: '按模板生成时间' },
        { value: 1, name: '按交易生成时间' }
      ],
      statusArray: [{ value: 1, name: '售卖中' }, { value: 3, name: '已下架' }],
      deviceArray: [
        { value: '', name: '全部平台' },
        { value: '1', name: 'PC' },
        { value: '2', name: 'APP' }
      ],
      orders: {
        temp_create_time: {
          order: 1,
          sort_key: 'temp_create_time'
        },
        order_counts: {
          order: -1,
          sort_key: 'order_counts'
        },
        actual_costs: {
          order: -1,
          sort_key: 'actual_costs'
        },
        xk_temp_free4creative: {
          order: -1,
          sort_key: 'xk_temp_free4creative'
        },
        share_order_count: {
          order: -1,
          sort_key: 'share_order_count'
        },
        product_member_valid_work: {
          order: -1,
          sort_key: 'product_member_valid_work'
        },
        share_should_total_fee: {
          order: -1,
          sort_key: 'share_should_total_fee'
        },
        valid_work_users: {
          order: -1,
          sort_key: 'valid_work_users'
        },
        valid_work_count: {
          order: -1,
          sort_key: 'valid_work_count'
        },
        product_valid_work_pv: {
          order: -1,
          sort_key: 'product_valid_work_pv'
        },
        template_exposure_uv: {
          order: -1,
          sort_key: 'template_exposure_uv'
        },
        update_work_users: {
          order: -1,
          sort_key: 'update_work_users'
        },
        valid_point: {
          order: -1,
          sort_key: 'valid_point'
        }
      }
    }
  },
  created() {
    const { nav } = this.$route.params
    const index = this.tabArray.findIndex(item => item === nav)

    this.initDefaultTime()
    if (index > -1) {
      this.defaultTabIndex = index > -1 ? index : 0
      this.changeTab(this.defaultTabIndex)
    } else {
      this.getList()
    }
  },
  methods: {
    handleOnchange(e) {
      console.log(e)
    },
    changeTab(index) {
      let attrGroupIds = Object.values(this.mobanEnum)
      this.filterParam.attrGroupId = attrGroupIds[index]
      this.initFilter()
      this.dataList = []
      this.tableShow = false
      this.getList(1, () => {
        this.tableShow = true
      })
    },
    timeSearchClick() {
      if (!this.month) this.month = this.getNow('yyyy-MM')
      const monthRange = this.getMonthRange(this.month)
      this.filterParam.beginDate = this.filterParam.timeType === 0 ? this.timeRange[0] : monthRange[0]
      this.filterParam.endDate = this.filterParam.timeType === 0 ? this.timeRange[1] : monthRange[1]
      this.getList(1)
    },
    getDefaultTime() {
      var date = new Date()
      return formatDate(date, 'yyyy-MM-dd')
    },
    getFileUrl(attach) {
      return attach.temp_type === 15 && attach.tmbPath ? attach.tmbPath : Vue.env.host.file + attach.tmbPath
    },
    openDetail(row) {
      if (row.status === 3) return
      if (this.filterParam.attrGroupId === 2) {
        window.open(Vue.env.host.store + '/h5/detail/' + row.id, '_blank')
      } else if (this.filterParam.attrGroupId === 7) {
        window.open(Vue.env.host.store + '/h2/detail/' + row.id, '_blank')
      } else if (this.filterParam.attrGroupId === 10) {
        window.open(Vue.env.host.store + '/h5l/detail/' + row.id, '_blank')
      } else if (this.filterParam.attrGroupId === 11) {
        window.open(Vue.env.host.store + '/h5e/detail/' + row.id, '_blank')
      }
    },
    // 跳转到编辑
    openScene(code) {
      window.open(Vue.env.host.base + '/c/' + code, '_blank')
    },

    /**
       * ------------------------------------------------------------------------
       *  列表选择框操作以及弹窗操作
       * ------------------------------------------------------------------------
       */

    editPriceFunc(item) {
      getLastUpdatePrice({
        productId: item.id,
        time: Math.round(new Date() / 1000),
        showkerId: this.$store.state.user.userInfo.id
      }).then(res => {
        res = res.data
        if (res.success === true) {
          this.dialog
            .openPrice({
              ...res.map,
              platform: item.platform,
              currentPrice: item.order_amount,
              id: item.id
            })
        }
      })
    },
    addCat(item) {
      // TODO 详情
      this.dialog.openTagFrame({
        id: item.id,
        code: item.code,
        cover: item.tmbPath,
        type: this.filterParam.attrGroupId
      })
    },

    /**
       * ------------------------------------------------------------------------
       * 筛选业务
       * ------------------------------------------------------------------------
       */
    initDefaultTime() {
      this.timeRange = [this.getDayAgo(7), this.getNow()]
      this.month = this.getNow('yyyy-MM')

      const monthRange = this.getMonthRange(this.month)
      this.filterParam.beginDate = this.filterParam.timeType === 0 ? this.timeRange[0] : monthRange[0]
      this.filterParam.endDate = this.filterParam.timeType === 0 ? this.timeRange[1] : monthRange[1]
    },
    initFilter() {
      this.filterParam.pageNo = 1
      this.filterParam.pageSize = 10
      this.filterParam.sortBy = 'desc'
      this.filterParam.status = ''
      this.filterParam.title = ''
      this.filterParam.timeType = 0
      this.filterParam.orderField = 'temp_create_time'
      this.filterParam.platForm = ''
      this.filterParam.price = ''
      this.title = ''
      this.initDefaultTime()
    },
    searchTitle() {
      this.filterParam.title = this.title
      this.getList(1)
    },
    priceSelectChange(value) {
      this.getList(1)
    },
    timeSelectChange(value) {
      this.initDefaultTime()
      if ((this.filterParam.attrGroupId === this.mobanEnum.H5 || this.filterParam.attrGroupId === this.mobanEnum.Hl) && this.filterParam.timeType === 1) {
        this.filterParam.orderField = 'valid_point'
      } else {
        this.filterParam.orderField = 'temp_create_time'
      }
      this.getList(1)
    },
    getList(type, cb) {
      if (type === 1) {
        this.filterParam.pageNo = 1
      }
      let para = {
        ...this.filterParam,
        showkerId: this.$store.state.user.userInfo.id
        // showkerId: '8a8080f0589b354d0158a9baa9ea002d' // todo
        // type: this.selectType
      }

      showkerScenes(para).then(res => {
        res = res.data
        if (res && res.map) {
          this.page.total = res.map.total
          this.page.pageNo = res.map.pageNo
          this.page.pageSize = res.map.pageSize
          this.dataList = res.map.rows
          this.bakList = JSON.parse(JSON.stringify(res.map.rows))
          if (cb) cb()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleCurrentChange(page) {
      this.filterParam.pageNo = page
      this.getList()
    },
    itemChange(value, value2) {
      this.filterParam.sortBy = value
      this.filterParam.orderField = value2
      for (let key in this.orders) {
        if (key !== value2) {
          this.orders[key].order = -1
        }
      }
      this.getList(1)
    },
    getNow(formatStr = 'yyyy-MM-dd') {
      let nowdate = new Date()
      return formatDate(nowdate, formatStr)
    },
    getDayAgo(day) {
      let nowdate = new Date()
      var oneWeek = new Date(nowdate - day * 24 * 3600 * 1000)
      return formatDate(oneWeek, 'yyyy-MM-dd')
    },
    getMonthRange(data) {
      const dateArr = data.split('-')
      return [formatDate(new Date(dateArr[0], dateArr[1] - 1, 1), 'yyyy-MM-dd'), formatDate(new Date(dateArr[0], dateArr[1], 0), 'yyyy-MM-dd')]
    },
    // 导出表格
    exportData() {
      let exportPara = JSON.parse(JSON.stringify(this.filterParam))
      delete exportPara['pageNo']
      delete exportPara['pageSize']
      exportPara['showkerId'] = this.$store.state.user.userInfo.id
      const queryString = Object.entries(exportPara).map(([key, value]) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      }).join('&')
      window.location.href = Vue.env.host.eqshow + '/showker/center/exportStatics?' + queryString
    }
  }
}
</script>

<style lang="scss" scoped>
.template-name-group {
  display: inline-block;
  vertical-align: middle;
  width: 233px;

  .edit-name {
    display: none;
    height: 36px;
    line-height: 36px;
    padding: 6px;
    border: 1px dashed;
    width: 100%;
  }

  .template-name {
    display: block;
    white-space: nowrap;
    overflow: hidden;
  }
}

.template-name-group:hover {
  .edit-name {
    display: block;
  }

  .template-name {
    display: none;
  }
}

.module-dialog-content {
  ul li {
    position: relative;
    border-bottom: 1px solid #ccd5db;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;

    .name {
      display: inline-block;
      vertical-align: middle;
      width: 200px;
      height: 36px;
      line-height: 36px;
    }
  }

  .catagary {
    float: right;
  }
}
.bar-search {
  margin-top: 2px;
  margin-left: 6px;
  padding-left: 0;
}
.query-bar {
  .el-form-item {
    margin-top: -1px;
  }
}
.export-btn {
  margin-top: 3px;
}
.month-picker {
  /deep/ .el-input__inner {
    border-radius:4px 0 0 4px;
    padding: 0 34px;
    align-items: center;
  }
}
</style>
